module.exports = __webpack_public_path__ + "static/media/headerPicRight3.d3bc73f7.svg";